import { useEffect } from 'react';
import {
  CioRegion,
  CustomerIO,
} from '../../../../packages/primitives/src/utils/CustomerIO';

export function useCustomerIO(): void {
  useEffect(() => {
    if (CustomerIO && CioRegion) {
      // Initialize CustomerIO for native platforms
      const initializeCustomerIO = async () => {
        try {
          const config = {
            cdpApiKey: 'fd8732943f8fe68bad7d',
            region: CioRegion.US,
            inApp: {
              siteId: '3510ab0e50bcb8f9c4ed',
            },
          };

          await CustomerIO.initialize(config);
        } catch (error) {
          console.error('Error initializing CustomerIO:', error);
        }
      };

      void initializeCustomerIO();
    }
  }, []);
}
